/**
 * Canonical PageConfiguration ContentType slugs used for global site search tabs.
 * Slugs must match CMS ContentType.slug (lowercase, hyphenated).
 */
export const PAGE_CONTENT_TYPE_SLUG = {
  STOREFRONT: 'store-front',
  SERVICE: 'service',
  LOCATION_SERVICE_PAGE: 'location-service-page',
  INDUSTRY_PAGE: 'industry-page',
  HIRE_DEVELOPER_PAGE: 'hire-developer-page',
} as const

export type PageContentTypeSlug =
  (typeof PAGE_CONTENT_TYPE_SLUG)[keyof typeof PAGE_CONTENT_TYPE_SLUG]

/** Content types that appear under the Services search tab. */
export const SERVICE_SEARCH_CONTENT_TYPE_SLUGS = [
  PAGE_CONTENT_TYPE_SLUG.STOREFRONT,
  PAGE_CONTENT_TYPE_SLUG.SERVICE,
  PAGE_CONTENT_TYPE_SLUG.LOCATION_SERVICE_PAGE,
] as const

/** Content types that appear under the Industries search tab. */
export const INDUSTRY_SEARCH_CONTENT_TYPE_SLUGS = [
  PAGE_CONTENT_TYPE_SLUG.INDUSTRY_PAGE,
] as const

/** Content types that appear under the Hire search tab. */
export const HIRE_SEARCH_CONTENT_TYPE_SLUGS = [
  PAGE_CONTENT_TYPE_SLUG.HIRE_DEVELOPER_PAGE,
] as const

export function typesenseContentTypeFilter(slugs: readonly string[]): string {
  return `contentTypeSlug:=[${slugs.join(',')}]`
}
